import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SocialInstagram = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="social-instagram"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.2327 0H6.76726C3.03573 0 0 3.03573 0 6.76726V18.2329C0 21.9642 3.03573 25 6.76726 25H18.2329C21.9642 25 25 21.9642 25 18.2329V6.76726C25 3.03573 21.9642 0 18.2327 0V0ZM12.5 19.3357C8.73068 19.3357 5.66424 16.2693 5.66424 12.5C5.66424 8.73068 8.73068 5.66424 12.5 5.66424C16.2693 5.66424 19.3357 8.73068 19.3357 12.5C19.3357 16.2693 16.2693 19.3357 12.5 19.3357ZM19.4992 7.27633C18.3853 7.27633 17.4793 6.37034 17.4793 5.25645C17.4793 4.14256 18.3853 3.23638 19.4992 3.23638C20.6131 3.23638 21.5192 4.14256 21.5192 5.25645C21.5192 6.37034 20.6131 7.27633 19.4992 7.27633Z" />
      <path d="M12.5 7.12985C9.53905 7.12985 7.12988 9.53883 7.12988 12.5C7.12988 15.4609 9.53905 17.8701 12.5 17.8701C15.4612 17.8701 17.8701 15.4609 17.8701 12.5C17.8701 9.53883 15.4612 7.12985 12.5 7.12985Z" />
      <path d="M19.4991 4.70218C19.1935 4.70218 18.9448 4.9509 18.9448 5.25645C18.9448 5.56201 19.1935 5.81073 19.4991 5.81073C19.8048 5.81073 20.0536 5.5622 20.0536 5.25645C20.0536 4.95071 19.8048 4.70218 19.4991 4.70218Z" />
    </svg>
  );
};
/* eslint-enable max-len */

SocialInstagram.defaultProps = {
  className: null,
};

SocialInstagram.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default SocialInstagram;
